<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.messageorders')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.messageorder.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.messageorder.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table [value]="messageorders" [paginator]="true" [rows]="20" stateStorage="local" stateKey="messageorders-list">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="active">{{ t('common.labels.active') }}
              <p-sortIcon field="active"></p-sortIcon>
            </th>
            <th pSortableColumn="title">{{ t('common.labels.title') }}
              <p-sortIcon field="title"></p-sortIcon>
            </th>
            <th>{{ t('common.labels.description') }}</th>
            <th>{{ t('common.labels.languages') }}</th>
          </tr>
          <tr class="filter">
            <th></th>
            <th>
              <p-columnFilter type="text" field="title" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="description" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-messageorder>
          <tr (click)="onOpen(messageorder)" (keyup.enter)="onOpen(messageorder)" hoverOnRight="admin.messageorder.show" tabindex="0">
            <td><span role="link"><i class="pi pi-ban" [ngClass]="{'pi-check': messageorder.active === true}"></i></span></td>
            <td><span role="link">{{messageorder.title}}</span></td>
            <td><span role="link">{{messageorder.description}}</span></td>
            <td><span role="link">{{messageorder.language_list}}</span></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

    </div>

  </app-list-view>
</ng-container>
